export const listingsTourClassNameStep1 = 'listings-step-1';

export const tourSteps = [
  {
    selector: `.${listingsTourClassNameStep1}`,
    content: 'Get started by configuring one of your listing storefronts!',
  },
];
